export const ANY_GENRE = 'Любой жанр';

export function getLibraryGenres(value) {
  if (typeof value === 'string') {
    try { value = JSON.parse(value); } catch { return []; }
  }
  if (!Array.isArray(value)) return [];
  const names = value.map(genre => {
    const name = typeof genre === 'string' ? genre : genre?.name || genre?.title || genre?.genre_name;
    return typeof name === 'string' ? name.trim() : '';
  }).filter(Boolean);
  return [...new Set(names)];
}

export function filterLibraryItems(items, {
  activeContentType = 'all', activeStatus = 'all', genre = ANY_GENRE,
  yearFrom = '', yearTo = '',
} = {}) {
  return items.filter(item => {
    if (activeContentType !== 'all' && item.category !== activeContentType) return false;
    if (activeStatus !== 'all' && item.status !== activeStatus) return false;
    if (genre !== ANY_GENRE && !getLibraryGenres(item.genres).includes(genre)) return false;
    if (yearFrom || yearTo) {
      const date = item.release_date || item.releaseDate;
      if (!date) return false;
      const year = new Date(date).getFullYear();
      if (!(year >= (yearFrom ? Number(yearFrom) : 1900) && year <= (yearTo ? Number(yearTo) : 2100))) return false;
    }
    return true;
  });
}
